import { iconSchema, nonEmptyString } from 'schemas/common';
import { courseSchema } from './course';

import { z } from 'zod';

export const translationSchema = z.object({
  appName: nonEmptyString,
  institution: nonEmptyString,
  titles: z.object({
    home: nonEmptyString,
  }),
  courseTerminology: z.object({
    base: nonEmptyString,
    plural: nonEmptyString,
  }),
  arrangements: z.object({
    completedSubjects: nonEmptyString,
    targetSubjects: nonEmptyString,
    creditPoints: nonEmptyString,
  }),
  subjectFormat: nonEmptyString,
  home: z.object({
    searchTitle: nonEmptyString,
    searchDescription: z.array(nonEmptyString),
    isEmpty: z.object({
      prompt: nonEmptyString,
    }),
    institutionSearch: z.object({
      placeholder: nonEmptyString,
      notFoundContent: z.object({
        heading: nonEmptyString,
        description: nonEmptyString,
      }),
    }),
    courseSearch: z.object({
      placeholder: nonEmptyString,
    }),
    searchResultTab: z.object({
      viewArticulationsTab: z.object({
        title: nonEmptyString,
        description: nonEmptyString,
        tooltip: z.array(nonEmptyString),
        viewButton: nonEmptyString,
      }),
      viewPrecedentsTab: z.object({
        title: nonEmptyString,
        description: nonEmptyString,
        tooltip: z.array(nonEmptyString),
      }),
    }),
  }),
  saved: z.object({
    title: nonEmptyString,
    description: z.array(nonEmptyString),
    groupCourseBy: courseSchema.keyof(),
  }),
  details: z.object({
    sourceDescription: nonEmptyString,
    targetDescription: nonEmptyString,
    description: nonEmptyString,
    articulationsTitle: nonEmptyString.optional(),
    precedentsTitle: nonEmptyString.optional(),
    conditions: z.object({
      title: nonEmptyString,
      description: nonEmptyString,
      list: z.array(nonEmptyString),
    }),
    validDates: z.object({
      title: nonEmptyString,
      description: nonEmptyString,
    }),
  }),
  help: z.object({
    title: nonEmptyString,
    description: z.array(nonEmptyString),
    sections: z.array(
      z.object({
        key: nonEmptyString,
        heading: nonEmptyString,
        content: z.array(
          z.object({
            key: nonEmptyString,
            question: nonEmptyString,
            answer: z.array(nonEmptyString),
          }),
        ),
      }),
    ),
  }),
  common: z.object({
    cohorts: z.object({
      international: z.object({
        label: nonEmptyString,
        alt: nonEmptyString,
        icon: nonEmptyString,
        color: nonEmptyString,
        filter: z.string().trim(),
      }),
      domestic: z.object({
        label: nonEmptyString,
        alt: nonEmptyString,
        icon: nonEmptyString,
        color: nonEmptyString,
        filter: z.string().trim(),
      }),
    }),
    icons: z.object({
      articulationsTab: iconSchema.optional(),
      courseSearchPrefix: iconSchema.optional(),
      domestic: iconSchema,
      externalLink: iconSchema,
      heartEmpty: iconSchema,
      heartFilled: iconSchema.optional(),
      info: iconSchema,
      infoFilled: iconSchema,
      institutionSearchDropdownItem: iconSchema.optional(),
      institutionSearchPrefix: iconSchema.optional(),
      international: iconSchema,
      logo: iconSchema,
      logoSmall: iconSchema,
      precedentsTab: iconSchema.optional(),
      question: iconSchema,
      searchEmpty: iconSchema.optional(),
    }),
    buttons: z.object({
      viewCredits: nonEmptyString,
      apply: nonEmptyString,
    }),
  }),
});
